import { defineStyleConfig } from '@chakra-ui/react';

export const CheckboxStyleConfig = defineStyleConfig({
  variants: {
    red03: {
      control: {
        bg: 'shade09',
        borderColor: 'shade06',
        _checked: {
          bg: 'red03',
          borderColor: 'red03',
          _hover: {
            bg: 'red03',
            borderColor: 'red03',
          }
        },
      },
    }
  }
});
